export default "__VITE_ASSET__BHKh4zNC__"